import SiteReport from 'app/modules/reports/views/SiteReport';

const SiteReportPage = () => {
  return <SiteReport />;
};

export default SiteReportPage;
